import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store/Store";
import { User } from "../../store/slices/authSlice/authSlice";
import { Row, Col, Form, Input, Alert } from "antd";
import { CheckOutlined, EditOutlined } from "@ant-design/icons";
import { useAppDispatch } from "../../store/reduxHooks";
import { API_SETTINGS_PROFILE } from "../../store/slices/profileSlice/profileSlice";
import { SupportEmail } from "../../components/SupportEmail/SupportEmail";
import {
  rulePhone,
  ruleRequired,
} from "../../constants/rules/RulesConstantsForms";
import { ProfileInfo } from "../../components/Profile/ProfileInfo/ProfileInfo";

interface IFormProfile {
  phone_number: string;
}
const style = { cursor: "pointer", color: "#001529" };

export const PageProfile: React.FC = () => {
  const selectProfile = useSelector(
    (state: RootState) => state.profileSlice
  ) as User;
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [phoneDisable, setPhoneDisable] = useState(true);
  const funSwap = () => {
    setPhoneDisable(!phoneDisable);
  };

  const onFinish = (values: { phone_number: string }): void => {
    dispatch(API_SETTINGS_PROFILE(values));
    funSwap();
  };

  // устанавливает данные формы
  useEffect(() => {
    form.setFieldsValue({ phone_number: selectProfile?.phone_number });
    return () => form.resetFields();
  }, [form, selectProfile]);

  return (
    <Row>
      {selectProfile && (
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <div>
            <h1>Мой Профиль</h1>
            <ProfileInfo />
            <Form
              disabled={phoneDisable}
              onFinish={onFinish}
              form={form}
              name="Profile_form"
              layout="vertical"
            >
              <Form.Item<IFormProfile>
                name="phone_number"
                label={"Телефон"}
                rules={[ruleRequired, rulePhone]}
              >
                <Input
                  suffix={
                    phoneDisable ? (
                      <EditOutlined style={style} onClick={() => funSwap()} />
                    ) : (
                      <CheckOutlined
                        style={style}
                        onClick={() => form.submit()}
                      />
                    )
                  }
                />
              </Form.Item>
            </Form>
            <Alert
              description={
                <SupportEmail
                  text={
                    "Для изменения данных или реквизитов в профиле вам необходимо обратиться в техподдержку по адресу"
                  }
                  align="left"
                />
              }
              type="info"
              showIcon
              style={{ padding: "12px" }}
            />
          </div>
        </Col>
      )}
    </Row>
  );
};
